import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class GenericResourcesQueryCriteriaClass extends BaseCriteriaModel {
  //For header
  tenant_hdr_guid?: Optional<string> = Optional.empty();
  instance_code?: Optional<string> = Optional.empty();

  //For line
  code?: Optional<string> = Optional.empty();
}

export class GenericResourcesCriteriaModelQuery {
  query = '';

  constructor(GenericResourcesCriteriaModel: GenericResourcesQueryCriteriaClass) {

    if (!GenericResourcesCriteriaModel) {
      return;
    }

    this.query += GenericResourcesCriteriaModel.tenant_hdr_guid.filter(x => x !== '').map(x => '&tenant_hdr_guid=' + x).orElse('');
    this.query += GenericResourcesCriteriaModel.instance_code.filter(x => x !== '').map(x => '&instance_code=' + x).orElse('');
    this.query += GenericResourcesCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');

    this.query += '&status=' + GenericResourcesCriteriaModel.status;
    this.query += '&orderBy=' + GenericResourcesCriteriaModel.orderBy;
    this.query += '&order=' + GenericResourcesCriteriaModel.order;
    this.query += '&offset=' + GenericResourcesCriteriaModel.offset + '&limit=' + GenericResourcesCriteriaModel.limit;
  }
}
